export default {
     api: 'https://backend.sbcat.org.br/public/api/',
     storage: 'https://backend.sbcat.org.br/storage/app/'
}